<button
    [ngStyle]="buttonStyles | theme"
    (click)="onClick()"
>
    <app-icon
        icon="account"
        [colorCss]="iconColorCss" 
        [sizeCss]="sizeCss">
    </app-icon>
</button>
